module.exports = __webpack_public_path__ + "resources/img/bg_solution_main3.e797ed533b436dc05f3371af2f55450d.png";